<template>
    <div>
        <datatable  :show-table="true" :columns="datatable2.columns" :rows="datatable2.rows"
                    :show-paginate="false"
                    class="mt-3"
                    :title="$t('course_information').toUpper()"
                    :lineNumbers="false">
        </datatable>

        <div class="d-flex justify-content-end mb-3 mt-3" v-if="checkPermission('staff_updatecoursesinstructorcanteach')">
            <b-button variant="primary" @click="createFormShow()">
                {{ $t('add_course') }}
            </b-button>
        </div>
        <datatable  :show-table="true" :columns="datatable.columns" :rows="datatable.rows"
                    :show-paginate="false"
                    :title="$t('approved_to_teach_disciplines').toUpper()"

                    :lineNumbers="false">
        </datatable>
        <CommonModal ref="createFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
            <template v-slot:CommonModalTitle>
                {{ $t('new').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <div>
                    <ValidationObserver ref="formModalValidate">
                        <div class="row">
                            <div class="col-12">
                                <b-form-group :label="$t('course')">
                                    <ValidationProvider name="course_id" v-slot="{ errors }">
                                        <course-auto-complete v-model="form.course_id" @courseSelected="selectedCourse($event)"/>
                                        <b-form-invalid-feedback v-for="(err, index) in errors" :key="index"> {{ err }} </b-form-invalid-feedback>
                                    </ValidationProvider>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center mt-2">
                            <b-button variant="primary"
                                      @click="createForm"
                                      :disabled="formLoading">
                                {{ $t('save') }}
                            </b-button>
                        </div>
                    </ValidationObserver>
                </div>
            </template>
        </CommonModal>
    </div>
</template>
<script>
    import StaffService from "@/services/StaffService";
    import qs from "qs";
    import SectionService from "@/services/SectionService";
    export default {
        props:{
            userId:{
                type: Number,
                required: true
            },
            canTeachCourses:{
                type: Array,
                default:[]
            }

        },
        created() {
            this.datatable.rows=this.canTeachCourses;
            this.getSections()
        },
        data() {
            return {
                formLoading:false,
                form:{},
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            sortable: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    permission: "joblog_show",
                                    callback: (row) => {
                                       this.delete(row.id)
                                    }
                                }
                            ]
                        },
                        {
                            label: this.$t('code'),
                            field: 'code',
                            hidden: false,
                            tdClass: 'text-center',
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('name'),
                            field: 'name',
                            hidden: false,
                            tdClass: 'text-center',
                            thClass: 'text-center',
                        },
                    ],
                    rows: [],
                    total: 0,
                },
                selectedCourseData:null,
                formProcess: null,
                datatable2: {
                    isLoading: false,
                    columns: [
                        {
                            label: this.toUpperCase('academic_year'),
                            field: 'academic_year',
                            hidden: false,
                            sortable: false
                        },
                        {
                            label: this.$t('semester'),
                            field: 'semester',
                            hidden: false,
                            tdClass: 'text-center',
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('course_code'),
                            field: 'course_code',
                            hidden: false,
                            tdClass: 'text-center',
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('course_name'),
                            field: 'course_name',
                            hidden: false,
                            tdClass: 'text-center',
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('section'),
                            field: 'section',
                            hidden: false,
                            tdClass: 'text-center',
                            thClass: 'text-center',
                        },

                    ],
                    rows: [],
                    total: 0,
                },
            }
        },
        methods: {
            getSections() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        filter: {
                            instructor_id: this.userId
                        }
                    },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };

                return SectionService.getAll(config)
                    .then((response) => {
                        this.datatable2.rows = response.data.data
                    })
                    .finally(() => {
                        this.datatable.isLoading = false;
                    });
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            createFormShow() {
                this.formId = null
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            delete(id) {
                this.deleteModal(() => {
                    this.datatable.rows=this.datatable.rows.filter((row) => {
                        return row.id !== id;
                    })
                    const formData={
                        course_ids:this.datatable.rows.map(item=>item.id)
                    }
                    StaffService.updateInstructorCanTeach(this.$route.params.id,formData)
                        .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.$emit('updatedData',true)
                        })
                        .catch(e => {
                            this.showErrors(e, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false
                        })
                })
            },
            selectedCourse(event){
                this.selectedCourseData=event
            },

            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid) {
                    this.formLoading = true;
                    const courseIds=this.canTeachCourses.map(c=>c.id)
                    const setCourseIds=[...courseIds,this.form.course_id]
                    const formData={
                        course_ids:setCourseIds,
                    }
                    StaffService.updateInstructorCanTeach(this.$route.params.id,formData)
                        .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.$emit('updatedData',true)
                            this.datatable.rows.push({
                                id: this.selectedCourseData.item.id,
                                code:this.selectedCourseData.item.code,
                                name:this.selectedCourseData.item.name,
                            })
                            this.$refs.createFormModal.$refs.commonModal.hide()
                            this.formClear()

                        })
                        .catch(e => {
                            this.showErrors(e, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false
                        })
                }
            }
        }
    }
</script>

